module.exports = __webpack_public_path__ + "img/addon-workspace-reservation.581034c5.png";